import React, { useEffect, useState, useCallback, useMemo } from "react";
import { ReactComponent as RightArrow } from "../../assets/svgs/rightArrow.svg";
import { ReactComponent as GreenEye } from "../../assets/svgs//greenEye.svg";
import TextStyles from "../../components/Elements/TextStyles/TextStyles";
import { Button } from "antd";
import { Tables } from "../../components/Elements/Tables/Tables";
import SortData from "../../components/Elements/SortData/SortData";
import CreateUsers from "./DailogBoxes/CreateUsers";
import EditUsersDialog from "./DailogBoxes/EditUsers";
import CustomButton from "../../components/Elements/Buttons/CustomButtons";
import { ReactComponent as EditIcon } from "../../assets/svgs/greenEdit.svg";
import { ReactComponent as DeleteIcon } from "../../assets/svgs/delete.svg";
import { SearchBar } from "../../components/Elements/Search/SearchBar";
import { API_URLS } from "../../api/apiUrls";
import { getApi, putApi } from "../../api/api_instance";
import { ReactComponent as FilterIcon } from "../../assets/svgs/filter-icon.svg";
import FilterDialog from "./DailogBoxes/FilterDialog";
import PopupCard from "../../components/Cards/PopupCard/PopupCard";

const Users = () => {
  const [users, setUsers] = useState([]);
  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [openCreateDailog, setOpenCreateDailog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [pageNo, setPageNo] = useState(1);
  const [filter, setFilter] = useState({});
   const [role, setRole] = useState(null);
  const [totalUsers, setTotalUsers] = useState(0);
  const [popup, setPopup] = useState({
    open: false,
    type: "",
    title: "",
    message: "",
  });
  const pageSize = 10;
  const [filterOpen, setFilterOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);

  const headers = useMemo(
    () => [
      { label: "Sr. No.", key: "serial" },
      { label: "Name", key: "name" },
      { label: "Email ID", key: "email" },
      { label: "Role", key: "role" },
      { label: "Action", key: "action" },
    ],
    []
  );

  // const fetchUsers = useCallback(
  //   async (page = 1) => {
  //     try {
  //       setLoading(true);
  //       const response = await getApi({
  //         apiUrl: API_URLS.USERS_GETALL(pageSize, page, searchTerm, filter),
  //       });

  //       if (response.data.users) {
  //         const usersData = response.data.users.map((user, index) => ({
  //           key: user._id,
  //           serial: (page - 1) * pageSize + (index + 1),
  //           name: user.name,
  //           email: user.email,
  //           role: <div className="uppercase"> {Array.isArray(user.role)
  //             ? user.role.join(", ")
  //             : user.role || "N/A"}</div>,
  //           status: user.status,
  //           action: (
  //             <div className="flex gap-4 items-center justify-center">
  //               <EditIcon
  //                 style={{ fontSize: "18px", cursor: "pointer" }}
  //                 onClick={() => {
  //                   setSelectedUser(user);
  //                   setOpenEditDialog(true);
  //                 }}
  //               />
  //               <DeleteIcon
  //                 style={{ cursor: "pointer" }}
  //                 onClick={() => handleDeleteUser(user._id)}
  //               />
  //             </div>
  //           ),
  //         }));

  //         setUsers(usersData);
  //         setTotalUsers(response.data.totalUsers); 
  //       } else {
  //         setUsers([]);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching form data:", error);
  //       setUsers([]);
  //     } finally {
  //       setLoading(false);
  //     }
  //   },
  //   [searchTerm, filter]
  // );

  // useEffect(() => {
  //   fetchUsers(pageNo);
  // }, [fetchUsers, pageNo]);

  // const handleDeleteUser = async (userId) => {
  //   try {
  //     setLoading(true);
  //     const res = await putApi({ apiUrl: API_URLS.DELETE_USER(userId) });
  //     if (res.success) {
  //       // toast.success("User Status Inactive successfully!");
  //       // setUserDeleteSuccess(true);
  //       fetchUsers(pageNo);
  //       setPopup({
  //         open: true,
  //         type: "success",
  //         title: "User Deleted",
  //         message: "The user has been successfully deleted",
  //       });
  //     } else {
  //       setPopup({
  //         open: true,
  //         type: "error",
  //         title: "Error",
  //         message: res.message || "Error in deleting User",
  //       });
  //     }
  //   } catch (error) {
  //     setPopup({
  //       open: true,
  //       type: "error",
  //       title: "Failed",
  //       message: error.message || "Failed to delete user.",
  //     });
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const handleSort = (key, order) => {
  //   setSortBy(key);
  //   setSortOrder(order);
  // };

  const filteredData = useMemo(() => {
    let data = [...users];
    if (sortBy && sortOrder) {
      data = SortData({ data, key: sortBy, order: sortOrder });
    }
    return data;
  }, [users, sortBy, sortOrder]);

  useEffect(() => {
    if (popup.open) {
      const timer = setTimeout(() => {
        setPopup((prev) => ({ ...prev, open: false }));
      }, 2000); // 2 seconds

      return () => clearTimeout(timer);
    }
  }, [popup.open]);

  return (
    <div
      style={{ padding: "40px", backgroundColor: "#fff" }}
      className="h-screen"
    >
      <div>
        <div className="flex justify-end text-xs font-light p-3">
          <p>Home</p>
          <span>/</span>
          <TextStyles color="gradient">Users</TextStyles>
        </div>
        <div>
          <div className="flex items-center mb-6 gap-2 text-xl text-[#06513D] font-bold px-2">
            {/* <Back onClick={() => navigate(-1)} className="cursor-pointer" /> */}
            <div>User</div>
          </div>

          <div
            style={{
              border: "1px solid #3BA2B959",
              borderRadius: "10px",
              paddingTop: "20px",
              boxShadow: "0px 0px 16px 0px #3BA2B91F",
            }}
          >
            <div className="flex justify-between px-3 mb-3">
              <div className="flex gap-4 pl-9">
                <div className="px-8 h-[42px] flex items-center justify-center border border-[#06513D] bg-[#B6D4D933] rounded-md text-[#06513D] text-base font-light">
                  TOTAL USERS {totalUsers}
                </div>
                <SearchBar
                  width="300px"
                  onSearch={(value) => { setSearchTerm(value); setPageNo(1) }}
                />
              </div>

              <div className="flex gap-4">
                <CustomButton
                  buttonType="button"
                  variant="ok"
                  buttonText=" + Add New"
                  onClick={() => setOpenCreateDailog(true)}
                  className="text-base font-normal px-8 py-7"
                />
                <Button
                  style={{
                    background: "#B6D4D9",
                    border: "solid 1px #06513D",
                  }}
                  className="text-[12px] bg-[#E6EDEB] hover:bg-[#F8F8F8] hover:text-[#06513D] text-[#06513D] font-light px-8 py-7"
                  onClick={() => setFilterOpen(true)}
                >
                  <FilterIcon /> FILTER
                </Button>
              </div>
            </div>
            <Tables
              data={filteredData}
              headers={headers}
              pageSize={pageSize}
              current={pageNo}
              total={totalUsers}
              loading={loading}
              onChange={(page) => {
                setPageNo(page);
              }}
              sortBy={sortBy}
              sortOrder={sortOrder}
              // onSort={handleSort}
            />
          </div>
          {openCreateDailog && (
            <CreateUsers
              onOpen={openCreateDailog}
              onClose={() => setOpenCreateDailog(false)}
              // onSuccess={() => {
              //   fetchUsers(pageNo);
              //   setOpenCreateDailog(false);
              // }}
              onSave={() =>
                setPopup({
                  open: true,
                  type: "success",
                  title: "User Created",
                  message: "User Created Successfully",
                })
              }
              onSuccessFalse={(msg) =>
                setPopup({
                  open: true,
                  type: "error",
                  title: "Failed",
                  message: msg || "Failed to create User",
                })
              }
            />
          )}
          {openEditDialog && selectedUser && (
            <EditUsersDialog
              onOpen={openEditDialog}
              onClose={() => setOpenEditDialog(false)}
              userData={selectedUser}
              // onUpdate={fetchUsers}
              onSave={() =>
                setPopup({
                  open: true,
                  type: "success",
                  title: "User Edited",
                  message: "User Edited Successfully",
                })
              }
              onSuccessFalse={(msg) =>
                setPopup({
                  open: true,
                  type: "error",
                  title: "Failed",
                  message: msg || "Failed to edit User",
                })
              }
            />
          )}
          {filterOpen && (
            <FilterDialog
              onOpen={filterOpen}
              setRole={setRole}
              role={role}
              onClose={() => { setFilterOpen(false); }}
              onFilterChange={(filterObj) => {
                setFilter(filterObj);
              }}
            />
          )}

          {popup.open && (
            <div className="fixed inset-0 bg-black/30 z-50 flex items-center justify-center">
              <PopupCard
                type={popup.type}
                title={popup.title}
                message={popup.message}
              />
            </div>
          )}

          {/* {userDeleteSuccess && (
            <SuccessDailogBox
              onOpen={userDeleteSuccess}
              onClose={() => setUserDeleteSuccess(false)}
              popuptype="delete"
              successMessage={"User Deleted Successfully"}
            />
          )}

          {userAddSuccessPopup && (
            <SuccessDailogBox
              onOpen={userAddSuccessPopup}
              onClose={() => setUserAddSuccessPopup(false)}
              popuptype="success"
              successMessage={"User Created Successfully"}
            />
          )}

          {updateUserSuccess && (
            <SuccessDailogBox
              onOpen={updateUserSuccess}
              onClose={() => setUpdateUserSuccess(false)}
              popuptype="success"
              successMessage={"User Updated Successfully"}
            />
          )} */}
        </div>
      </div>
    </div>
  );
};

export default Users;
